import React from 'react';
import { htmlEscapeJsonString } from "./htmlEscape.js";
export var createInsertHTML = function createInsertHTML(_ref) {
  var options = _ref.options,
    results = _ref.results,
    nonce = _ref.nonce;
  return function () {
    if (options.inserted) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    options.inserted = true;
    return /*#__PURE__*/React.createElement("script", {
      nonce: nonce,
      dangerouslySetInnerHTML: {
        __html: "window[Symbol.for(\"InstantSearchInitialResults\")] = ".concat(htmlEscapeJsonString(JSON.stringify(results)))
      }
    });
  };
};